import { Component, OnInit } from "@angular/core";
import { SettingsService } from "../../shared/services/settings.service";
import { AlertService } from "../../shared/services/alert.service";
import { SystemSetting } from "../../models/CommonModels";

@Component({
  selector: "app-system-settings",
  templateUrl: "./system-settings.component.html",
  styleUrls: ["./system-settings.component.css"],
})
export class SystemSettingsComponent implements OnInit {
  public systemSettings: SystemSetting[];
  public activeTab = "KPI";
  public bsConfig: any;
  constructor(
    private settingsService: SettingsService,
    private alertService: AlertService
  ) {}

  ngOnInit() {
    this.getSystemSettings();
    this.bsConfig = { dateInputFormat: "DD/MM" };
  }
  getSystemSettings() {
    this.settingsService.getSystemSettings().subscribe(
      (res) => {
        const _this = this;
        _this.systemSettings = [];
        res.forEach(function (setting) {
          if (setting.dataType === "DateTime") {
            setting.dateValue = new Date(setting.value);
          }
          _this.systemSettings.push(setting);
        });
      },
      (err) => {
        this.alertService.error(
          "Unable to fetch system settings. Please try again later."
        );
      }
    );
  }

  get kpiSettings(): SystemSetting[] {
    return (this.systemSettings || []).filter((setting) =>
      this.isKpiSetting(setting)
    );
  }

  get otherSettings(): SystemSetting[] {
    return (this.systemSettings || []).filter(
      (setting) => !this.isKpiSetting(setting)
    );
  }

  /**
   * Seeded GMP targets use codes like TargetScreeningLocalGMP and descriptions
   * such as "Target for local GMP screening", which do not contain the word "kpi".
   */
  private isKpiSetting(setting: SystemSetting): boolean {
    const description = (setting.description || "").toLowerCase();
    const code = (setting.systemSettingCode || "").toLowerCase();
    return description.includes("kpi") || code.startsWith("target");
  }

  saveChanges(systemSetting) {
    if (systemSetting.dataType === "DateTime") {
      systemSetting.value = systemSetting.dateValue.toISOString();
    }
    if (systemSetting.dataType === "Integer") {
      const raw = systemSetting.value;
      if (raw === null || raw === undefined || String(raw).trim() === "") {
        this.alertService.error("Value must be a whole number, 0 or greater.");
        return;
      }
      const n = Number(raw);
      if (!Number.isInteger(n) || n < 0) {
        this.alertService.error("Value must be a whole number, 0 or greater.");
        return;
      }
      systemSetting.value = String(n);
    }
    this.settingsService.saveSystemSetting(systemSetting).subscribe(
      (res) => {
        if (res) {
          this.alertService.success("Successfully updated system setting.");
        } else {
          this.alertService.error("Updating alert service failed.");
        }
      },
      (err) => {
        this.alertService.error("Updating alert service failed.");
      }
    );
  }
}
